import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap';
import photos from '../photo-manifest.json';
import ImageModal from './ImageModal';
import PanoramaModal from './PanoramaModal';
import StandardTabContent from './StandardTabContent';
import PanoramaTabContent from './PanoramaTabContent';

function Gallery() {
  const [categories, setCategories] = useState({});
  const [activeTab, setActiveTab] = useState('people');
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showPanoramaModal, setShowPanoramaModal] = useState(false);
  const [selectedPanorama, setSelectedPanorama] = useState(null);

  useEffect(() => {
    // Organize photos by category
    const categorizedPhotos = photos.photos.reduce((acc, photo) => {
      const category = photo.split('/')[0];
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(photo);
      return acc;
    }, {});

    setCategories(categorizedPhotos);
  }, []);

  useEffect(() => {
    // Check for hash in URL on component mount
    const hash = window.location.hash.substring(1);
    if (hash && categories[hash]) {
      setActiveTab(hash);
    } else if (Object.keys(categories).length > 0) {
      // If no hash or invalid hash, set default tab and update URL
      const defaultTab = 'people';
      setActiveTab(defaultTab);
      const currentPath = window.location.pathname + window.location.search;
      window.history.replaceState(null, null, `${currentPath}#${defaultTab}`);
    }
  }, [categories]);

  const handleTabSelect = (key) => {
    setActiveTab(key);
    // Update URL hash while preserving the current path
    const currentPath = window.location.pathname + window.location.search;
    window.history.pushState(null, null, `${currentPath}#${key}`);
  };

  const handleStandardImageClick = (photo) => {
    setSelectedImage(photo);
    setShowModal(true);
  };

  const handlePanoramaImageClick = (photo) => {
    setSelectedPanorama(photo);
    setShowPanoramaModal(true);
  };

  return (
    <Container className="w-75 mt-4">
      <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
        <Row>
          <Col>
            <Nav variant="tabs" className="mb-3">
              {Object.keys(categories).map(category => (
                <Nav.Item key={category}>
                  <Nav.Link eventKey={category} className="text-capitalize">
                    {category}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Col>
        </Row>
        <Row>
          <Col>
            <Tab.Content>
              {Object.entries(categories).map(([category, categoryPhotos]) => (
                <Tab.Pane key={category} eventKey={category}>
                  {category === 'panorama' ? (
                    <PanoramaTabContent
                      categoryPhotos={categoryPhotos}
                      onImageClick={handlePanoramaImageClick}
                    />
                  ) : (
                    <StandardTabContent
                      categoryPhotos={categoryPhotos}
                      onImageClick={handleStandardImageClick}
                    />
                  )}
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>

      <ImageModal 
        show={showModal}
        onHide={() => setShowModal(false)}
        selectedImage={selectedImage}
      />

      <PanoramaModal 
        show={showPanoramaModal}
        onHide={() => setShowPanoramaModal(false)}
        selectedPanorama={selectedPanorama}
      />
    </Container>
  );
}

export default Gallery;
